import { ActionType, TableColumn } from "../../../Component/Model/Table/Table";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { ActionsCell } from "../../../Component/Common/Components/DataTable/ActionsCell";
import {RequestTracker} from "../../../Component/Model/Dto/Staging/RequestTracker";
import {StringDateTimeHelper} from "../../../Component/Model/helpers";
import {useRecoilValue} from "recoil";
import {userRolesState} from "../../../State/user.Atom";
import {EE123PeopleRole_Edit, PeopleEditRole} from "../../../Component/Common/Constants/UserRoles";
import {RequestStatus} from "../../../Component/Model/Enum/ImportEnum";

interface RequestTrackerRows {
    payrollName: string;
    createdOn: string;
    statusDescription: string;
    completedOn: string;
    requestUsername: string;
    actions: ActionType[];
}

interface RequestTrackerTable {
    columns: Array<TableColumn>;
    rows: Array<RequestTrackerRows>;
}

export function RequestTrackerTableMapper(dataRows: RequestTracker.SearchDto[], openPayrollImport: () => void): RequestTrackerTable {

    const userRoles = useRecoilValue(userRolesState);

    const columns = [
        { Header: 'Created Date', accessor: 'createdOn', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Payroll(s)', accessor: 'payrollName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Status', accessor: 'statusDescription', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Completed', accessor: 'completedOn', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Fetched By', accessor: 'requestUsername', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataRows && dataRows.length > 0) {
        const rows = dataRows.map((item: RequestTracker.SearchDto) => {
            const payrollNames = item.payrollNames?.length
                ? item.payrollNames.filter(Boolean).join(", ")
                : "";

            const canImport = item.status === RequestStatus.ImportReady &&
                userRoles.some(r => r === EE123PeopleRole_Edit || r === PeopleEditRole);

            return {
                payrollName: payrollNames,
                createdOn: StringDateTimeHelper(item.createdOn.toString()),
                statusDescription: item.statusDescription,
                requestUsername: item.requestUsername,
                completedOn: StringDateTimeHelper(item.completedOn?.toString() ?? ""),
                actions: [
                    ...(canImport
                        ? [{
                            key: payrollNames,
                            label: 'Import',
                            icon: { name: 'cloud_upload', color: 'info' },
                            action: openPayrollImport
                        }]
                        : [])
                ]
            };
        });

        return { columns, rows };
    } else {
        return { columns, rows: [] };
    }
}